<template>
    <MainContent>
        <template v-slot:header>
            <h3 class="card-title pb-3">Página de prueba para el datáfono</h3>
        </template>
        <template v-slot:content>
            <b-row>
                <b-col cols="12">
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-form @submit.prevent="actualizar">
                        <b-form-group
                            id="datafono-label"
                            label="Seleccione un datafono:"
                            label-for="datafono-input"
                        >
                            <b-form-select
                                v-model="datafono"
                                @change="setDatafono"
                            >
                                <template #first selected>
                                    <b-form-select-option :value="null" disabled>Seleccione un datáfono</b-form-select-option>
                                </template>
                                <template v-for="datafono in datafonos">
                                    <b-form-select-option :key="datafono.id" :value="datafono">{{ datafono.nombre_comercio }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group
                            id="nombre-comercio-label"
                            label="Nombre del comercio:"
                            label-for="nombre-comercio-input"
                        >
                            <b-form-input
                                id="nombre-comercio-input"
                                v-model="datafono.nombre_comercio"
                                type="text"
                                placeholder="Nombre del comercio"
                            />
                        </b-form-group>
                        <b-form-group
                            id="comercio-label"
                            label="Comercio:"
                            label-for="comercio-input"
                        >
                            <b-form-input
                                id="comercio-input"
                                v-model="datafono.comercio"
                                type="text"
                                placeholder="Comercio"
                                required
                            />
                        </b-form-group>
                        <b-form-group
                            id="clave-label"
                            label="Clave de firma:"
                            label-for="clave-input"
                        >
                            <b-form-input
                                id="clave-input"
                                v-model="datafono.key"
                                type="text"
                                placeholder="Clave de firma"
                                required
                            />
                        </b-form-group>
                        <b-form-group
                            id="terminal-label"
                            label="Terminal:"
                            label-for="terminal-input"
                        >
                            <b-form-input
                                id="terminal-input"
                                v-model="datafono.terminal"
                                type="number"
                                placeholder="terminal"
                                required
                            />
                        </b-form-group>
                        <b-form-group
                            id="numero-serie-label"
                            label="Número de serie:"
                            label-for="numero-serie-input"
                        >
                            <b-form-input
                                id="numero-serie-input"
                                v-model="datafono.numero_serie"
                                type="text"
                                placeholder="Número de serie"
                            />
                        </b-form-group>
                        
                        <b-form-group
                            id="puerto-label"
                            label="Puerto:"
                            label-for="puerto-input"
                        >
                            <b-form-input
                                id="puerto-input"
                                v-model="datafono.puerto"
                                type="text"
                                placeholder="Puerto"
                            />
                        </b-form-group>
                        <b-form-group
                            id="version-label"
                            label="Versión:"
                            label-for="version-input"
                        >
                            <b-form-input
                                id="version-input"
                                v-model="datafono.version"
                                type="text"
                                placeholder="Versión"
                            />
                        </b-form-group>
                        <b-button type="submit" variant="primary">Actualizar datos</b-button>
                    </b-form>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col cols="12">
                    <h1>Probar pago:</h1>
                    <b-button @click="reiniciar()">Reiniciar</b-button>
                </b-col>
                <b-col cols="12" v-if="! cobrar">
                    <b-form @submit.prevent="onSubmit">
                        <b-form-group
                            id="importe-label"
                            label="Importe:"
                            label-for="importe-input"
                        >
                            <b-form-input
                                id="importe-input"
                                v-model="importe"
                                type="text"
                                placeholder="Importe"
                                required
                            />
                        </b-form-group>
                        <b-button type="submit" variant="primary">Realizar pago</b-button>
                    </b-form>
                </b-col>
                <b-col cols="12" v-if="cobrar" class="mt-3">
                    <DatafonoComponent
                        :importe="parseFloat(importe)"
                        @pagoCorrecto="pagoCorrecto"
                    />
                    <b-button v-if="! response_pago" @click="cobrar = false;">Cancelar</b-button>
                </b-col>
                <b-col cols="12" v-if="response_pago">
                    <a 
                        target="_blank"
                        :href="api_base + '/usuarios/datafono/recibo-pago?tid=' + configuracion.hash_teatro + '&api_key=' + api_key + '&response=' + JSON.stringify(response_pago)"
                        class="button btn-primary"
                    >
                        Imprimir recibo de compra
                    </a>
                    <a 
                        target="_blank"
                        :href="api_base + '/usuarios/datafono/recibo-devolucion?tid=' + configuracion.hash_teatro + '&api_key=' + api_key + '&pedido_response=' + JSON.stringify(response_pago) + '&devolucion_response=' + JSON.stringify(response_devolucion)"
                        class="button btn-primary ml-3"
                        v-if="response_devolucion"
                    >
                        Imprimir recibo de devolución
                    </a>
                </b-col>
                <b-col cols=12 v-if="response_pago && !response_devolucion" class="mt-3">
                    <b-button v-if="! devolucion" @click="devolucion = true">Realizar devolución</b-button>
                    <DatafonoDevolucionComponent 
                        v-else
                        :importe="parseFloat(importe)"
                        :pedido="response_pago.pedido"
                        :rts="response_pago.identificadorRTS"
                        @devolucionCorrecta="devolucionCorrecta"
                    />
                </b-col>
            </b-row>
        </template>        
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import DatafonoComponent from '@/components/backend/datafono/DatafonoComponent';
import DatafonoDevolucionComponent from '@/components/backend/datafono/DatafonoDevolucionComponent';

export default {
    data() {
        return {
            api_base: process.env.VUE_APP_API_BASE,
            datafonos: null,
            importe: 0,
            cobrar: false,
            devolucion: false,
            response_pago: null,
            response_devolucion: null,
            datafono: {}
        }
    },
    created() {
        this.getDatafonos();
    },
    methods: {
        getDatafonos() {
            const params = {
                filters : {}
            };

            this.$store.dispatch(this.config.getVuexAlias('back.usuarios.datafonos.get'), params).then(res => {
                this.datafonos = res.data.data;
            });
        },
        actualizar() {
            const params = {
                filters : {},
                comercio: this.datafono.comercio,
                key: this.datafono.key,
                terminal: this.datafono.terminal,
                numero_serie: this.datafono.numero_serie,
                puerto: this.datafono.puerto,
                version: this.datafono.version,
                datafono_id: this.datafono.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.usuarios.datafonos.update'), params).then(res => {
                this.getDatafono();
                this.checkUser();
            });
        },
        checkUser() {
            const data = {
                filters: {
                    tid : this.configuracion.hash_teatro
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('check'), data);
        },
        onSubmit() {
            this.cobrar = true;
        },
        pagoCorrecto(response) {
            this.response_pago = response;
        },
        devolucionCorrecta(response) {
            this.response_devolucion = response;
        },
        reiniciar() {
            this.cobrar = false;
            this.response_devolucion = null;
            this.response_pago = null;
        },
        setDatafono() {
            this.$store.dispatch('setActiveDatafono', this.datafono);
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        api_key() {
            return localStorage.getItem('token');
        }
    },
    components: {
        MainContent, DatafonoComponent, DatafonoDevolucionComponent
    }
}
</script>